import ObjectUtil from '@leverege/object-util'
import { parseOptions } from './Utils.js'

function all( arrOrObj, opts ) {
  const options = parseOptions( opts, Infinity )
  options.limit = Infinity
  return doLimit( arrOrObj, options )
}

async function limit( arrOrObj, opts ) {
  const options = parseOptions( opts, 10 )
  return doLimit( arrOrObj, options )
}

async function doLimit( arrOrObj, opts ) {

  const { limit, handleReject } = opts

  let keys = null
  let arr = arrOrObj

  if ( !Array.isArray( arrOrObj ) && typeof arr === 'object' ) {
    const obj = ObjectUtil.flatten( arrOrObj, '/' )
    keys = Object.keys( obj )
    arr = keys.map( k => obj[k] )
  }

  let next = limit
  let error = false

  const results = []
  await Promise.all( arr.slice( 0, limit ).map( async ( func, i ) => {
    let index = i
    while ( !error && index < arr.length ) {
      try {
        results[index] = await arr[index]() //eslint-disable-line
      } catch ( err ) {
        if ( handleReject ) {
          results[index] = err
        } else if ( error === false ) {
          error = true
          throw err
        }
      }
      index = next++
    }
  } ) )

  if ( keys ) {
    const structured = ObjectUtil.copy( arrOrObj )
    keys.forEach( ( k, i ) => {
      const arr = k.split( '/' )
      let c = structured
      for ( let n = 0; n < arr.length; n++ ) {
        if ( n === arr.length - 1 ) {
          c[arr[n]] = results[i]
        } else {
          c = c[arr[n]]
        }
      }
    } ) 

    return structured
  }
  return results
}

export default {
  limit,
  all
}
